import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { AnnouncementBar } from './components/AnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
const HERO_MOCKUP = 'https://cdn.magicpatterns.com/uploads/4uX3G3wUEjM6S8x4n4MirU/MOCKUP_PRINCIPAL.png';
const CHECKOUT_ORIGIN = 'https://functional-fitness-365.impultienda.ar';

// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // English by default; browsers may offer their built-in translator.
    document.documentElement.lang = 'en';
    document.documentElement.removeAttribute('translate');
    document.documentElement.classList.remove('notranslate');
    document.head.querySelectorAll('meta[name="google"][content="notranslate"]').forEach(m => m.remove());
    document.title = 'Functional Fitness 365™ — Your entire year of functional classes, ready';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'en'
    });
    ensureMeta({
      name: 'language',
      content: 'English'
    });
    ensureMeta({
      name: 'description',
      content: 'Functional Fitness 365: 6 volumes, 365 ready-to-teach sessions and 5 strategic bonuses. Your entire year of functional fitness classes, ready today for $19 USD. Pay in your local currency.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#020617'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_MOCKUP,
      fetchpriority: 'high'
    });
    // Warm up the checkout connection so CTA clicks navigate instantly.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="en" className="min-h-screen w-full bg-slate-950 text-slate-300 selection:bg-blue-600 selection:text-white" data-id="element-0" data-mp="1i3kvcy1mtwil">
      <MetaPixel data-id="element-1" data-mp="1m44rpzedsw3o" />
      <SocialProofPopup data-id="element-2" data-mp="1m3l8mfczw1o2" />
      <ExitIntentModal data-id="element-3" data-mp="1m70o3jakzcq0" />
      <AnnouncementBar data-id="element-4" data-mp="6onu8ps6bguv" />
      <main data-id="element-5" data-mp="6ncm6drp3mxy">
        <Hero data-id="element-6" data-mp="6nmbs08tvs34" />
        <SocialProof data-id="element-7" data-mp="6n4auqb80pov" />
        <Testimonials1 data-id="element-8" data-mp="aq0y4ubph9z5" />
        <Problem data-id="element-9" data-mp="aqit7nmmti5h" />
        <ProductTomos data-id="element-10" data-mp="ar27mud2poer" />
        <Bonuses data-id="element-11" data-mp="arc1wu55ihq9" />
        <UrgencyCounter data-id="element-12" data-mp="ano6tqk25n9f" />
        <Pricing data-id="element-13" data-mp="qwvrwf96wp6w" />
        <Testimonials2 data-id="element-14" data-mp="qxfazzaktjmi" />
        <Guarantee data-id="element-15" data-mp="qyq9pkp6016r" />
        <FAQ data-id="element-16" data-mp="qz8h9dha21tz" />
        <CostOfNotHaving data-id="element-17" data-mp="m6fayl65ulfs" />
        <FinalCTA data-id="element-18" data-mp="m65k6vdaka91" />
      </main>
      <Footer data-id="element-19" data-mp="m4uhyzzhvak1" />
      <StickyMobileCTA data-id="element-20" data-mp="m4cblaj4bfye" />
    </div>;
}